
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getToken } from '../../reducers/auth';
import {
    getProject,
    getProjectKatuzeItems
} from '../../reducers/project';
import { getAnalyze, getOpsubActual, getDefault } from '../../reducers/analyzeDefunctPar';
import { getAnalyzeData } from '../../reducers/analyzeDefunctPar/analyze';
import { getIsknDate, getOpsubItem } from '../../reducers/analyzeDefunctPar/reducer';
import { getOpsubItems } from '../../reducers/common/opsub';
import analyzeDefunctParGetActions from '../../sagas/analyzeDefunctPar';

import AnalyzeDefunctParView from './AnalyzeDefunctPar.view';

const AnalyzeDefunctParState = () => {

    const dispatch = useDispatch();
    const analyzeDefunctParActions = analyzeDefunctParGetActions(dispatch);

    const token = useSelector(state => getToken(state.auth));

    const project = useSelector(state => getProject(state.project));
    const projectKatuzeItems = useSelector(state => getProjectKatuzeItems(state.project));
    const projectKatuzeKod = projectKatuzeItems.map(item => item.kod);

    const analyzeLoader = useSelector(state => getAnalyze(state.analyzeDefunctPar));
    const isknDate = useSelector(state => getIsknDate(getDefault(state.analyzeDefunctPar)));
    const opsubItem = useSelector(state => getOpsubItem(getDefault(state.analyzeDefunctPar)));
    const opsubActualLoaded = useSelector(state => getOpsubActual(state.analyzeDefunctPar));
    const opsubItems = useSelector(state => getOpsubItems(getOpsubActual(state.analyzeDefunctPar)));
    const analyzeData = useSelector(state => getAnalyzeData(getAnalyze(state.analyzeDefunctPar)));

    const canAnalyze = opsubItem && isknDate;

    React.useEffect(() => {
        if (opsubItems.length === 0) {
            analyzeDefunctParActions.getOpsubActual(
                token, project.id, projectKatuzeKod, 'actual'
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClickAnalyze = () => {
        if (canAnalyze) {
            const isknDates = [isknDate];

            analyzeDefunctParActions.analyzeDefunctPar(
                token, project.id, projectKatuzeKod, isknDates, opsubItem.id
            );
        }
    }

    const handleChangeOpsub = (opsubItem) => {
        analyzeDefunctParActions.setOpsubItem(opsubItem);
    }

    const handleChangeIsknDate = (isknDate) => {
        analyzeDefunctParActions.setIsknDate(isknDate);
    }

    return (
        <AnalyzeDefunctParView
            analyzeData={analyzeData?.data}
            canAnalyze={canAnalyze}
            isAnalyzeLoaded={analyzeLoader.loaded}
            isAnalyzeLoading={analyzeLoader.loading}
            isOpsubActualLoaded={opsubActualLoaded.loaded}
            isknDate={isknDate}
            opsubItem={opsubItem}
            opsubItems={opsubItems}
            onClickAnalyze={handleClickAnalyze}
            onChangeOpsub={handleChangeOpsub}
            onChangeIsknDate={handleChangeIsknDate}
        />
    )
}

export default AnalyzeDefunctParState;
